export enum PageType {

    DepositTopUp = "DepositTopUp",
    DepositSuccessful = "DepositSuccessful",
}
